import * as TabsPrimitive from '@radix-ui/react-tabs';
import React from 'react';

import { cn } from '@/services/utils';

const TabsTrigger = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.Trigger>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
    <TabsPrimitive.Trigger
        ref={ref}
        className={cn(
            `tw-inline-flex tw-items-center tw-justify-center
             tw-whitespace-nowrap
             tw-border-none tw-rounded-sm
             tw-px-3 tw-py-1.5
             tw-text-t-sm tw-font-medium
             tw-ring-offset-background tw-transition-all
             focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2
             disabled:tw-pointer-events-none
             disabled:tw-opacity-50
             data-[state=active]:tw-bg-secondary-lighter
             data-[state=active]:tw-text-foreground
             data-[state=active]:tw-shadow-sm
             tw-cursor-pointer`,
            className
        )}
        {...props}
    />
));

TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

export { TabsTrigger };
